//Reanimator "In View" animation script
var didScroll = true;
window.onscroll = setscroll;
window.onresize = setscroll;
var reanimator_elements = document.querySelectorAll('.animation-element');

function check_if_in_view() {

  for(let element of reanimator_elements) {

    const rect = element.getBoundingClientRect();
    const window_height = (window.innerHeight || document.documentElement.clientHeight);    
    const top_threshold = window_height * 0.5;
    const bottom_threshold = window_height * -0.5;
    
    if(
        ( (rect.top >= bottom_threshold) && (rect.top <= top_threshold) ) || 
        ( (rect.bottom - window_height <= top_threshold) && (rect.bottom - window_height >= bottom_threshold) )
    ) {
        element.classList.add('in-view');
    }
  }
}

function setscroll() {
    didScroll = true;
}

setInterval(function() {
    if(didScroll) {
        didScroll = false;
        check_if_in_view();
        user_scrolled();
    }
}, 200);

//Set up scroll events for "scrolled"   
function user_scrolled() {
    var window_top_position = window.pageYOffset | document.body.scrollTop;
  
    if(window_top_position > '50'){
        document.body.classList.add('user-scrolled');
    }
    if(window_top_position < '50'){
        document.body.classList.remove('user-scrolled');;
    }
}